module.exports = __webpack_public_path__ + "img/guanyu.68429e68.png";